import React from "react";
import Account from "../../common/account";
import { getCustomerProfile, updateCustomerProfile } from "../../../services/customer.service";

interface Props {
  customerId: string;
  loggedInUserId?: string;
}

const CustomerAccount: React.FC<Props> = ({ customerId, loggedInUserId }) => {
  const title = customerId === loggedInUserId ? "Your Profile" : "Customer Profile";
  const subtitle = customerId === loggedInUserId ? "Keep your details up to date" : "Keep customer details up to date";

  return (
    <Account
      userId={customerId}
      loggedInUserId={loggedInUserId}
      getProfile={getCustomerProfile}
      updateProfile={updateCustomerProfile}
      title={title}
      subtitle={subtitle}
      showSignature={true}
    />
  );
};

export default CustomerAccount;
